    /* Login Module */

    login.classy.controller({
        name: 'LoginController',
        inject: ['$scope', '$state', 'authServiceFactory', '$location', '$window', 'easyLog', 'bowser'], //, 'easyLogV3'
        init: function()
        {
            $(".index-loading-area").addClass("hidden");
            if (typeof this.easyLog !== "undefined")
                this.$.easyLog = this.easyLog.data;
            if (typeof this.easyLogV3 !== "undefined")
                this.$.easyLogV3 = this.easyLogV3.data;
            this.$.form = {};
            this.$.ismToken = this.$location.search().ismToken;
            this.$.committeeToken = this.$location.search().committeeToken;
            this.$.form.user = this.$location.search().user;
            this.$.form.pass = this.$location.search().pass;
            if (typeof this.$.committeeToken !== "undefined");
                this.$.form.token = this.$.committeeToken;
            if (typeof this.$.form.user !== "undefined")
                this.login();
            this.$.styling = 0;
            this.$.bowser = this.bowser;
        },
        login: function(user, pass, token)
        {
            $(".index-loading-area").removeClass("hidden");
            $("div.off-canvas-wrap").hide();
            if (user !== undefined)
                this.$.form.user = user;
            if (pass !== undefined)
                this.$.form.pass = pass;
            if (token !== undefined)
                this.$.form.token = token;
            if ((typeof this.$.form.user == 'undefined' && typeof this.$.form.pass == 'undefined') || this.$.form.pass == '')
            {
                this.$.message = "invalid";
                $("div.off-canvas-wrap").show();
                $(".index-loading-area").addClass("hidden");
                return false;
            }
            if (this.$.form.user.indexOf('@') !== -1) {

                var parent = this;
                this.authServiceFactory.load(this.$.form).then(function(data)
                {
                    if (data instanceof Array && data[0].status == 200 && data[0].data.deleted==0) {
                        window.location = "#/schoolside/applications";
                    }
                    else {
                        parent.$.message = "invalid";
                        $("div.off-canvas-wrap").show();
                        $(".index-loading-area").addClass("hidden");
                    }
                });
            }
            else {
                $("div.off-canvas-wrap").show();
                $(".index-loading-area").addClass("hidden");
                this.$.message = "v3";
                return false;
            }
        },
        easyLogClick: function(user, pass)
        {
            this.$.form.user = user;
            this.$.form.pass = pass;
            this.$.login();
        }
    });


    /* End Login Module */
